<template>
  <section class="pl-3 pr-3 pt-3" v-if="customer">
    <section>
      <div v-if="profileType !== 'professional'">
        <i class="fas fa-user-alt text-info"></i> โปรไฟล์ในระบบ
      </div>
      <div class="mt-3">
        <template v-if="customer.customer">
          <a href="" @click.prevent="profileType = 'customer'">
            <div class="text-center profile" v-if="customer.customer">
              <div>
                <template v-if="customer.customer.picture">
                  <img v-lazy="customer.customer.picture" class="rounded-circle img-circle-lg" width="60" alt="">
                </template>
                <template v-else>
                  <img src="https://beneat.co/images/unknown-user.png" width="60">
                </template>
              </div>
              <div class="mt-1" v-if="customer.customer.flag_red || customer.customer.flag_black">
              <span style="color: #d63447;" v-if="customer.customer.flag_red">
                <i class="fa fa-heart"></i>
              </span>
                <span style="color: #d63447;" v-if="customer.customer.flag_black">
                <i class="fa fa-heart"></i><i class="fa fa-heart"></i>
              </span>
              </div>
              <div class="mt-1 profile-name">
                {{ customer.customer.full_name }}
              </div>
              <div class="text-muted">
                คุณลูกค้า
              </div>
            </div>
          </a>
          <div class="pt-2 d-flex">
            <div>
              <button class="btn btn-primary btn-sm" @click="createOrder()">สร้างรายการจองอ้างอิงลูกค้า</button>
            </div>
            <div class="pl-2" v-if="hasBigCleaningTag">
              <button class="btn btn-success btn-sm big-cleaning-quote-card-button" @click="openQuoteCardModal">สร้างการ์ดใบเสนอราคา</button>
            </div>
          </div>
          <template v-if="customer.other_accounts && customer.other_accounts.length">
            <hr>
            <div>Account อื่นที่ใช้เบอร์โทร/อีเมลเดียวกัน</div>
            <div>
              <ul style="margin-left: 20px; font-size: 14px;">
                <li v-for="(account, index) in customer.other_accounts" :key="index">
                  <a :href="`https://admin-test.beneat.co/user/${account.id}`" target="_blank">{{ account.full_name }}</a>
                </li>
              </ul>
            </div>
          </template>
        </template>
        <template v-else>
          <div v-if="hasBigCleaningTag">
            <button class="btn btn-success btn-sm big-cleaning-quote-card-button" @click="openQuoteCardModal">สร้างการ์ดใบเสนอราคา</button>
          </div>
        </template>
        <template v-if="customer.professional">
          <template v-if="customer.customer">
            <hr>
          </template>

          <div v-if="profileType === 'professional'" style="font-size: 14px;">
            <ul  class="list-unstyled" style="padding-left: 10px;">
              <li>
                [ ID: <a :href="`https://admin-test.beneat.co/professional/${customer.professional.id}/profile`" target="_blank">{{ customer.professional.id }}</a> ] Name: <a :href="`https://admin-test.beneat.co/professional/${customer.professional.id}/profile`" target="_blank">{{ customer.professional.full_name }}</a>
              </li>
              <li>
                Group: <span v-html="$options.filters.professionalGroupId(customer.professional.professional_group_id, customer.professional.status)"></span>
                <span> &nbsp; สถานะ &nbsp;
                 <span v-if="Number(customer.professional.active) === 1" class="badge badge-pill badge-success">Online</span>
                 <span v-else-if="Number(customer.professional.active) === 0" class="badge badge-pill badge-secondary">Offline</span>

                </span>
              </li>
              <li v-if="customer.professional.province">
                จังหวัด: {{ customer.professional.province.name_th }}
              </li>
            </ul>
            <div style="padding-left: 10px;">
              <img v-if="customer.professional.has_vacuum_cleaner"
                   v-b-tooltip.hover title="มีเครื่องดูดฝุ่น"
                   src="@/assets/img/badge-vacuum-cleaner.svg"
                   alt="" width="32">

              <img v-if="customer.professional.cleaning_service === 1"
                   v-b-tooltip.hover title="บริการทำความสะอาด"
                   src="@/assets/img/cleaning.png" alt="" width="32">

              <img v-if="customer.professional.ironing_service === 1"
                   v-b-tooltip.hover title="บริการรีดผ้า"
                   src="@/assets/img/iron.png" alt="" width="32">

              <template v-if="customer.professional.transportation_type">
                <img v-if="customer.professional.transportation_type.name_th === 'รถยนต์ส่วนตัว'"
                     v-b-tooltip.hover title="มีรถยนต์ส่วนตัว"
                     src="@/assets/img/sport-car.png" alt="" width="32">

                <img v-if="customer.professional.transportation_type.name_th === 'รถจักรยานยนต์'"
                     v-b-tooltip.hover title="มีรถจักรยานยนต์"
                     src="@/assets/img/scooter.png" alt="" width="32">

                <img v-if="customer.professional.transportation_type.name_th === 'รถขนส่งสาธารณะ'"
                     v-b-tooltip.hover title="เดินทางรถขนส่งสาธารณะ"
                     src="@/assets/img/school-bus.png" alt="" width="32">
              </template>

              <img v-if="customer.professional.vaccinated"
                   v-b-tooltip.hover title="ฉีดวัคซีนแล้ว"
                   src="@/assets/img/syringe.png" alt="" width="32">

              <img v-if="customer.professional.is_excellent === 1"
                   v-b-tooltip.hover title="ผู้ให้บริการยอดเยี่ยม"
                   src="@/assets/img/ic_badge_excellent.png" alt="" width="32">
            </div>

            <template v-if="(customer.professional.inconvenience_pets && customer.professional.inconvenience_pets.length > 0) || (customer.professional.partners && customer.professional.partners.length > 0)">
              <hr>
              <div style="padding-top: 10px; padding-left: 10px;">
                <p v-if="customer.professional.inconvenience_pets && customer.professional.inconvenience_pets.length > 0"><span class="font-weight-bold">ไม่สะดวกรับงานที่มีสัตว์เลี้ยง:</span> {{ customer.professional.inconvenience_pets.join(', ') }}</p>
                <p v-if="customer.professional.partners && customer.professional.partners.length > 0"><span class="font-weight-bold">งาน Partner:</span> {{ customer.professional.partners.join(', ') }}</p>
              </div>
            </template>

            <hr>
            <div style="padding-top: 10px; padding-left: 10px;">
              <div class="form-group">
                <span style="font-size: 1rem;" for="">ข้อจำกัด  <a href="#" @click.prevent="isEditingLimitation = true"><i class="fas fa-pencil-alt"></i></a></span>
                <template v-if="isEditingLimitation">
                  <textarea class="form-control" rows="3" v-model="customer.professional.limitation"></textarea>
                  <div class="text-right">
                    <button class="btn btn-sm btn-primary" @click.prevent="submitEditLimitation(customer.professional.id)" style="margin-top: 10px;">บันทึก</button>
                  </div>
                </template>
                <template v-else>
                  <p style="white-space: pre-wrap;">{{ customer.professional.limitation }}</p>

                  <div v-if="customer.professional.limitation_update_by_admin" class="text-right">
                    <small>แก้ไขล่าสุด: {{ customer.professional.limitation_updated_at | prettyDate }} <br> {{ customer.professional.limitation_update_by_admin.name }}</small>
                  </div>
                </template>
              </div>
            </div>

            <hr>
            <div style="padding-top: 10px; font-size: 1rem;" v-if="customer.professional.professional_today_order_list">
              <i class="far fa-list-alt"></i> ตารางงานวันนี้
              <ul class="list-unstyled">
                <li v-for="(item, index) in customer.professional.professional_today_order_list" :key="index">
                  <a :href="`https://admin-test.beneat.co/order/${item.id}`"
                     target="_blank">
                    #{{ item.code }} - {{ item.cleaning_date | prettyDate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>

        <template v-if="customer.applicant">
<!--          <a href="" @click.prevent="profileType = 'applicant'">-->
          <hr>
            <div class="text-center profile">
              <div>
                <template v-if="customer.applicant.full_picture">
                  <img v-lazy="customer.applicant.full_picture" class="rounded-circle img-circle-lg" width="60" alt="">
                </template>
                <template v-else>
                  <img src="https://beneat.co/images/unknown-user.png" width="60">
                </template>
              </div>
              <div class="mt-1 profile-name" style="overflow: visible;">
                <ul class="list-unstyled" style="padding-left: 10px;">
                  <li>
                    Applicant ID: <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.id_card_number}`" target="_blank">{{ customer.applicant.id }}</a>
                  </li>
                  <li>
                    Name: <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.id_card_number}`" target="_blank">{{ customer.applicant.full_name }}</a>
                  </li>
                </ul>
              </div>
              <div class="text-muted">
                ผู้สมัคร {{ customer.applicant.is_techician_register ? '(คุณช่าง)' : '' }}
              </div>
            </div>
<!--          </a>-->
        </template>

      </div>
      <hr>
    </section>
    <section>
      <div v-if="profileType !== 'professional'">
        <i class="fas fa-info-circle text-info"></i> ข้อมูล
      </div>
      <div class="mt-3">
        <template v-if="profileType === 'customer' && customer.customer">
          <div class="row">
            <div class="col-6">
              <div style="width: fit-content;">
                <div class="profile" style="padding-left: 20px;">
                  <template v-if="customer.customer.picture">
                    <img v-lazy="customer.customer.picture" class="rounded-circle img-circle-lg" width="60" alt="">
                  </template>
                  <template v-else>
                    <img src="https://beneat.co/images/unknown-user.png" width="60">
                  </template>
                </div>
                <div class="profile mt-1" style="padding-left: 14px;">
                  <span v-html="$options.filters.vipStatus(customer.customer.beneat_order_qty, 30)"></span>
                </div>
                <div class="mt-1" style="padding-left: 34px;" v-if="customer.customer.flag_red || customer.customer.flag_black">
                  <span style="color: #d63447;" v-if="customer.customer.flag_red">
                    <i class="fa fa-heart"></i>
                  </span>
                  <span style="color: #d63447;" v-if="customer.customer.flag_black">
                    <i class="fa fa-heart"></i><i class="fa fa-heart"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-6 profile-detail">
              <ul class="list-unstyled">
                <li>
                  Coin: {{ customer.customer.total_credits ? parseFloat(customer.customer.total_credits) : 0 }}
                </li>
                <li>
                  Point: {{ customer.customer.total_points ? parseFloat(customer.customer.total_points) : 0 }}
                </li>
                <li>
                  โค้ดส่วนลด:
                  <template v-if="customer.customer && customer.customer.promo_code &&  customer.customer.promo_code.length > 0">
                    <a href="#" @click.prevent="openModalPromoCode">{{ customer.customer.promo_code.length }}</a>
                  </template>
                  <template v-else>0</template>
                </li>
              </ul>
            </div>
          </div>
          <div class="row mt-2 profile-detail">
            <div class="col-6">
              <ul class="list-unstyled" style="padding-left: 10px;">
                <li>
                  Customer ID: <a :href="`https://admin-test.beneat.co/user/${customer.customer.id}`" target="_blank">{{ customer.customer.id }}</a>
                </li>
                <li>
                  Name: <a :href="`https://admin-test.beneat.co/user/${customer.customer.id}`" target="_blank">{{ customer.customer.full_name }}</a>
                </li>
              </ul>
            </div>
            <div class="col-6">
              <ul class="list-unstyled">
                <li>
                  Booking: {{ customer.customer.beneat_order_qty ? Math.round(customer.customer.beneat_order_qty) : 0 }}
                </li>
                <li>
                  Review: {{ customer.customer.review_qty ? Math.round(customer.customer.review_qty) : 0 }}
                </li>
                <!-- <li v-if="false">
                  Rating: {{ customer.customer.avg_rating ? parseFloat(customer.customer.avg_rating).toFixed(1) : 0 }}
                </li> -->
              </ul>
            </div>
          </div>
          <div class="row mt-2 profile-detail">
            <div class="col-12">
              <a :href="'https://admin-test.beneat.co?email=' + customer.customer.email" target="_blank" class="btn btn-sm btn-warning">การจองของคุณลูกค้า <i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
          <hr>
        </template>
        <template v-if="profileType === 'applicant' && customer.applicant">
          <div class="row">
            <div class="col-12">
              <div style="width: fit-content;">
                <div class="profile" style="padding-left: 20px;">
                  <template v-if="customer.applicant.full_picture">
                    <img v-lazy="customer.applicant.full_picture" class="rounded-circle img-circle-lg" width="60" alt="">
                  </template>
                  <template v-else>
                    <img src="https://beneat.co/images/unknown-user.png" width="60">
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2 profile-detail">
            <div class="col-6">
              <template v-if="!customer.applicant.id_card_number">
                <ul class="list-unstyled" style="padding-left: 10px;">
                  <li>
                    Applicant ID : <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.tel}`" target="_blank">{{ customer.applicant.id }}</a>
                  </li>
                  <li>
                    Name: <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.tel}`" target="_blank">{{ customer.applicant.full_name }}</a>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul class="list-unstyled" style="padding-left: 10px;">
                  <li>
                    Applicant ID: <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.id_card_number}`" target="_blank">{{ customer.applicant.id }}</a>
                  </li>
                  <li>
                    Name: <a :href="`${conditionApplicantURLRegister(customer.applicant)}?keyword=${customer.applicant.id_card_number}`" target="_blank">{{ customer.applicant.full_name }}</a>
                  </li>
                </ul>
              </template>
            </div>
            <div class="col-6">
              <ul class="list-unstyled">
                <li>
                  <!-- Booking: {{ customer.professional }} -->
                </li>
              </ul>
            </div>
          </div>
          <hr>
        </template>
      </div>
    </section>
    <!-- Latest booking info -->
    <section v-if="latestOrder">
      <div><i class="fas fa-calendar-alt text-info"></i> ข้อมูลการจองล่าสุด</div>
      <div class="card shadow-sm mt-2">
        <div class="card-body text-remark">
          <div class="d-flex justify-content-start align-items-center">
            <div class="flex-fill">
              <div>
                <a :href="`https://admin-test.beneat.co/order/${latestOrder.id}`"
                   target="_blank">
                  #{{ latestOrder.code }}
                </a>
                (ID: {{ latestOrder.id }})
              </div>
            </div>
            <div class="flex-fill text-right">
              <i class="fas fa-calendar-alt"></i> {{ latestOrder.cleaning_date | bookingDate }}
            </div>
          </div>
          <div class="pt-2">
            <span v-if="latestOrder.service" v-html="$options.filters.platform(latestOrder.platform)"></span> {{ latestOrder.service.name_th }}
            <span v-if="latestOrder.package_id">(แพ็คเกจ)</span>
            <span v-if="latestOrder.subscription_id">(Subscription)</span>
            <a v-if="latestOrder.service_request" target="_blank"
               :href="`https://admin-test.beneat.co/service-requests-new/form?id=${latestOrder.service_request.id}`">
              #{{ latestOrder.service_request.id }}
            </a>

            <b-badge variant="warning">
              {{ (latestOrder.extra) ? (latestOrder.work_hour - latestOrder.extra.work_hour) : latestOrder.work_hour }}
              <span v-if="latestOrder.order_additional_hours">+{{ latestOrder.order_additional_hours.work_hour }}</span> ชม.
            </b-badge>
          </div>
          <div class="pt-2" v-if="latestOrder.extra">
            <i class="fas fa-plus text-info"></i>
            {{ latestOrder.extra.name_th }}
            <b-badge variant="warning">{{ latestOrder.extra.work_hour }} ชม.</b-badge>
          </div>
          <div class="pt-2"><i class="fas fa-map-marker-alt text-danger"></i> {{ latestOrder.province ? latestOrder.province.name_th : '' }}</div>
          <div class="pt-2"><i class="fas fa-home text-secondary"></i> {{ latestOrder.address }}</div>
          <div class="pt-1" v-if="latestOrder.latitude !== null && Number(latestOrder.latitude) !== 0.00000000">
            <a :href="`https://maps.google.com?q=${latestOrder.latitude},${latestOrder.longitude}`" target="_blank">
              {{ `https://maps.google.com?q=${latestOrder.latitude},${latestOrder.longitude}` }}
            </a>
          </div>
          <div class="pt-2" v-if="latestOrder.place_size"><i class="fas fa-building text-secondary"></i> {{ latestOrder.place_size.name_th }}</div>
          <div v-if="latestOrder.professional">
            <hr>
            <div class="d-flex justify-content-start align-items-center">
              <div>
                <img :src="latestOrder.professional.picture_url" alt="" width="48" class="rounded-circle img-circle">
              </div>
              <div class="pl-3">
                <div>
                  <a :href="`https://admin-test.beneat.co/professional/${latestOrder.professional.id}/profile`"
                     target="_blank">
                    ID:{{ latestOrder.professional.id }} - {{ latestOrder.professional.full_name }}
                  </a>
                  (Gen {{ latestOrder.professional.generation_id }})
                </div>
                <div>Tel: {{ latestOrder.professional.phone }}</div>
              </div>
            </div>
            <router-link :to="`/conversations/${latestOrder.conversation_id}`"
                         target="_blank"
                         class="btn btn-outline-info btn-block btn-sm mt-3"
                         v-if="latestOrder.conversation_id">เปิดแชทคุยกับคุณแม่บ้าน
            </router-link>
          </div>
        </div>
      </div>
      <hr>
    </section>
    <section v-if="customerDetail">
      <customer-notes :customer="customerDetail"
                      :notes="notes"
                      :profileType="profileType"
      ></customer-notes>
      <hr>
    </section>
    <sweet-modal ref="promoCodeModal" overlay-theme="dark">
      <div class="row">
        <div class="col-12">
          <h4>ส่วนลดที่คุณลูกค้าใช้ได้:</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead>
              <tr class="info">
                <th>#</th>
                <th>Code</th>
                <th>ส่วนลด</th>
                <th>ใช้ไปแล้ว / จำนวนสิทธิ์</th>
                <th>วันหมดอายุ</th>
                <th>ประเภท</th>
              </tr>
              </thead>
              <tbody v-if="customer.customer && customer.customer.promo_code && customer.customer.promo_code.length > 0">
              <tr v-for="(item, index) in customer.customer.promo_code" :key="index"
                  :style="[ isExpiredCode(item) ? { 'color': 'red' } : '' ]">
                <td>
                  {{ index + 1 }}
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.discount }} %</td>
                <td>{{ item.promo_code_usage.length }} / {{ item.quota }}</td>
                <td>{{ moment(item.expire_date).format('DD-MM-YYYY') }}</td>
                <td>
                  <span :style="[item.code_type == 'claim' ? {color:'red'} : '']">{{ item.code_type }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </sweet-modal>
    <quote-card-modal ref="quoteCardModal" :selectedConversation="selectedConversation"></quote-card-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CustomerNotes from './CustomerNotes'
import QuoteCardModal from './components/QuoteCardModal'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
    CustomerNotes,
    QuoteCardModal
  },
  props: {
    customer: Object,
    selectedConversation: Object
  },
  data () {
    return {
      profileType: '',
      customerDetail: null,
      latestOrder: null,
      isEditingLimitation: false
    }
  },
  computed: {
    ...mapState({
      notes: state => state.conversation.notes,
      admin: state => state.admin.admin
    }),
    // Big Cleaning tag: the row ids differ between environments.
    bigCleaningTagId () {
      return (process.env.NODE_ENV !== 'production') ? 1297 : 266
    },
    // The quotation card only makes sense on a Big Cleaning enquiry, so the
    // button appears only once the conversation carries that tag.
    hasBigCleaningTag () {
      if (this.selectedConversation.type === 'LineAtConversation') {
        const tags = (this.selectedConversation) ? this.selectedConversation.tags : null
        if (!tags || !tags.length) {
          return false
        }
        return tags.some(tag => Number(tag.id) === this.bigCleaningTagId)
      }
      return false
    }
  },
  watch: {
    'customer': {
      handler: function (newValue) {
        const oldProfileType = this.profileType
        this.customerDetail = this.customer
        this.initialProfileTypeFromUser(this.customer)
        if (oldProfileType === this.profileType) {
          this.updateNote()
        }
      },
      deep: true
    },
    'profileType': function (newVal) {
      console.log('profileType', newVal)
      this.updateNote()
    }
  },
  methods: {
    ...mapActions('conversation', ['fetchNotes']),
    conditionApplicantURLRegister (applicant) {
      if (applicant) {
        if (!applicant.is_techician_register) {
          return 'https://admin-test.beneat.co/report/professional-register'
        } else {
          return 'https://admin-test.beneat.co/report/technician-register'
        }
      }
    },
    initialProfileTypeFromUser (customer) {
      if (customer && (customer.customer || customer.professional || customer.applicant)) {
        if (customer.customer) {
          this.profileType = 'customer'
          this.latestOrder = (customer.customer.latest_order) ? customer.customer.latest_order : null
        } else if (customer.professional) {
          this.profileType = 'professional'
        } else if (customer.applicant) {
          this.profileType = 'applicant'
        }
      } else if (this.selectedConversation) {
        if (this.selectedConversation.customer_type === 'customer') {
          this.profileType = 'customer'
        } else if (this.selectedConversation.customer_type === 'beneat_professional') {
          this.profileType = 'professional'
        } else if (this.selectedConversation.customer_type === 'professional') {
          this.profileType = 'applicant'
        }
      }
    },
    async submitEditLimitation (professionalId) {
      try {
        const limitation = this.customer.professional ? this.customer.professional.limitation : ''
        const { data } = await axios.put('/beneat/professionals/' + professionalId, {
          limitation: limitation,
          limitation_update_by: this.admin.id
        })
        this.isEditingLimitation = false
        this.customer.professional.limitation_updated_at = data.professional.limitation_updated_at
      } catch (err) {
        this.$swal({
          text: 'ผิดพลาด ' + err.message,
          type: 'error'
        })
      }
    },
    openModalPromoCode () {
      this.$refs.promoCodeModal.open()
    },
    openQuoteCardModal () {
      this.$refs.quoteCardModal.open()
    },
    isExpiredCode (promoCode) {
      if (promoCode.expire_date) {
        let checkDate = moment().isAfter(promoCode.expire_date)
        return checkDate
      }
      return false
    },
    moment: function (date) {
      return moment(date)
    },
    updateNote () {
      if (this.customer && (this.customer.customer || this.customer.professional || this.customer.applicant)) {
        let params = {}
        let url = ''
        if (this.profileType === 'customer') {
          const customer = this.customer.customer
          url = `/beneat/users/${customer.id}/note`
        } else if (this.profileType === 'professional') {
          const professional = this.customer.professional
          url = `/beneat/professionals/${professional.id}/note`
        } else if (this.profileType === 'applicant') {
          const applicant = this.customer.applicant
          url = '/beneat/professionals/register/note'
          params = {
            professional_register_id: applicant.id
          }
        }
        const payload = {
          url,
          params,
          profile_type: this.profileType
        }
        this.fetchNotes(payload)
      }
    },
    objectToQueryString (obj) {
      const params = new URLSearchParams()
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key])
        }
      }
      return params.toString()
    },
    createOrder () {
      const customer = this.customer.customer
      let params = {
        auto_fill: 1,
        user_id: customer.id,
        email: customer.email
      }
      const queryParams = this.objectToQueryString(params)
      let url = `https://admin-test.beneat.co/order/create-multiple?${queryParams}`
      if (process.env.NODE_ENV !== 'production') {
        url = `http://localhost:8090/order/create-multiple?${queryParams}`
      }
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.customerDetail = this.customer
    this.initialProfileTypeFromUser(this.customer)
    /* if (this.customer.customer) {
      this.profileType = 'customer'
      this.latestOrder = (this.customerDetail.customer.latest_order) ? this.customerDetail.customer.latest_order : null
    } else if (this.customer.professional) {
      this.profileType = 'professional'
    } else if (this.customer.applicant) {
      this.profileType = 'applicant'
    } */
  }
}
</script>

<style scoped lang="scss">
.profile {
  margin-right: 1rem;
  font-size: 85%;
  display: inline-block;
}

.profile-detail {
  font-size: 85%;
}

.profile-name {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
